export const histologyModule = {
  id: "histology",
  title: "Blood Circulation",
  sections: [
    {
      type: "text",
      content: `<h3>Colon Anatomy</h3>
 <div class="highlight-box">
          <strong>Quick Facts:</strong>
          <ul>
            <li>📏 Size: About ,....</li>
            <li>⚖️ Weight: XX grams each</li>
            <li>📍 Location: XXX </li>
            <li>🎨 Color: XX in appearance</li>
          </ul>
        </div>


        ,`,

      image: "/images/lungs/LungAnatomy.jpg",
    },
    {
      type: "question",
      text: "",
      options: ["2", "3", "4", "5"],
      correct: 2,
      explanation: "",
    },
    {
      type: "question",
      text: "",
      options: ["2", "3", "4", "5"],
      correct: 2,
      explanation: "",
    },
    {
      type: "question",
      text: "",
      options: ["2", "3", "4", "5"],
      correct: 2,
      explanation: "",
    },
    {
      type: "text",
      content: "",
      image: "/images/heart/blood-flow.jpg",
    },
    {
      type: "question",
      text: "",
      options: ["2", "3", "4", "5"],
      correct: 2,
      explanation: "",
    },
    {
      type: "question",
      text: "",
      options: ["2", "3", "4", "5"],
      correct: 2,
      explanation: "",
    },
    {
      type: "question",
      text: "",
      options: ["2", "3", "4", "5"],
      correct: 2,
      explanation: "",
    },
  ],
};
